export default "{\n    \"pageTitle\": \"Edit Work Order\",\n    \"heading\": \"Edit Work Order\",\n    \"submitButtonLabel\": \"Save\"\n}\n"